import { AxiosInstance } from 'axios';
import { ProductService } from '../../../../../services/ProductMvp';
import { IProductFindParam } from '../../../../../services/ProductMvp/types';

export const useProduct = () => {
  const service = new ProductService();

  const getProduct = async (params: IProductFindParam) => {
    const products = await service.getProduct(params);
    return products[0];
  };

  const getRelatedProducts = async (params: IProductFindParam) => {
    const maximumSize = 4;
    const relatedProducts = await service.getRelatedProducts(params);
    const notRespectsMaximumSize =
      relatedProducts?.related?.length > maximumSize;
    if (notRespectsMaximumSize) {
      relatedProducts.related = relatedProducts.related.slice(0, maximumSize);
    }
    return relatedProducts;
  };

  const getProductArticle = async (
    categoryName: string,
    api?: AxiosInstance
  ) => {
    const response = await service.getProductArticle(categoryName, api);
    return response;
  };

  return {
    getProduct,
    getRelatedProducts,
    getProductArticle
  };
};
